export enum Currencies {
    USDT = 'USDT',
    AUD = 'AUD',
    KRW = 'KRW'
}

export const availableCurrencies = [Currencies.AUD, Currencies.KRW];
